<script>
  import './style.scss';
  import template from './template.html';
  import { CloseIcon } from '../icons.js';


  export default {

    props: {},

    created () {},

    computed: {},

    methods: {

      confirm () {}
    },

    mounted () {},

    template,

    data () {

      return {

        editorOptions: {
          usageStatistics: false,
          hideModeSwitch: true,
          toolbarItems: [
            'heading',
            'bold',
            'italic',
            'strike',
            'divider',
            'link',
          ]
        },

        comment: "",

        isActive: false,
      }
    },

    components: {
      CloseIcon,
    }
  };
</script>
